// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

/**
 * Skeleton placeholder for the bundles table while data is loading.
 */
export function BundlesTableSkeleton() {
  const rows = Array.from({ length: 5 }, (_, i) => i);

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="medium" sx={{ tableLayout: 'fixed' }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: '16%', minWidth: 160 }}>Name</TableCell>
            <TableCell sx={{ width: '24%', minWidth: 220 }}>
              Description
            </TableCell>
            <TableCell sx={{ minWidth: 240 }}>Items</TableCell>
            <TableCell sx={{ width: 180 }}>Last updated</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row}>
              <TableCell>
                <Skeleton variant="text" width="80%" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="60%" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="70%" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={80} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
